import { Component, OnInit } from '@angular/core';
import { trigger, transition, query, style, animate, group } from '@angular/animations';

const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '200px' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(-200px)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(200px)' }))], {
      optional: true,
    }),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '200px' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(200px)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-200px)' }))], {
      optional: true,
    }),
  ]),
];
@Component({
  selector: 'app-graph-check-outtime',
  templateUrl: './graph-check-outtime.component.html',
  styleUrls: ['./graph-check-outtime.component.css'],
      animations: [
        trigger('animImageSlider', [
          transition(':increment', right),
          transition(':decrement', left),
        ]),]
})
export class GraphCheckOuttimeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.loopSlide();
  }

  counter: number = 0;
  images = [
    'https://ichef.bbci.co.uk/ace/standard/976/cpsprodpb/14235/production/_100058428_mediaitem100058424.jpg',
    'https://gratisography.com/wp-content/uploads/2024/11/gratisography-augmented-reality-800x525.jpg',
    'https://gratisography.com/wp-content/uploads/2024/11/gratisography-augmented-reality-800x525.jpg',
    'https://gratisography.com/wp-content/uploads/2024/11/gratisography-augmented-reality-800x525.jpg'
  ];

  agentlist = [
    'Big C A',
    'Big C B',
  ]

  loopSlide() {
    setTimeout(() => {
      this.onNext();
      this.loopSlide();
    }, 60000*5);
  }

  onNext() {
    if (this.counter != this.images.length - 1) {
      this.counter++;
    }
    else
    {
      this.counter = 0;
    }
  }

  onPrevious() {

    if (this.counter > 0) {
      this.counter--;
    }
    else  {
      this.counter = this.images.length-1;
    }
  }
}
